<script>
  import { onMount } from 'svelte';
  import Footer from '../components/Footer.svelte';
  import Header from '../components/Header.svelte';
  import SmsVerifyOverlay from '../components/SmsVerifyOverlay.svelte';
  import RegistrationFormSection from '../sections/RegistrationFormSection.svelte';
  import { resetForm, formError, hydratePromoFromRef, hydrateTicketQty } from '../stores/registration.js';
  import { resolveProductId } from '../sections/registration.js';

  export let product = 'basic';
  export let productIdOverride = null;

  $: productId = productIdOverride ?? resolveProductId(product);

  onMount(() => {
    resetForm();
    hydrateTicketQty();
    hydratePromoFromRef(productId);
    return () => resetForm();
  });
  // NB: hydratePromoFromRef НЕ привязан к смене productId через реактив —
  // async-запрос для старого productId может resolve после нового и
  // перезаписать promo state. Promo-ref хидрейтится один раз на mount;
  // при SPA-навигации между разными `?productId=...` юзер увидит промо для
  // первого продукта (редкий кейс, edge-case осознанно принят).

  function onSuccess() {
    formError.set('');
  }

  function onAfterPayment(message) {
    if (typeof window !== 'undefined') alert(message);
  }
</script>

<div class="registration-page">
  <Header />

  <main class="registration-main">
    <RegistrationFormSection {productId} productSlug={product} />
  </main>

  <SmsVerifyOverlay {productId} {onSuccess} {onAfterPayment} />

  <Footer />
</div>

<style>
  .registration-page {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    background: #000000;
    color: #ffffff;
  }

  .registration-main {
    flex: 1 0 auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding-top: 76px;
  }

  @media (max-width: 1279px) {
    .registration-main {
      padding-top: 86px;
    }
  }

  @media (max-width: 767px) {
    .registration-main {
      padding-top: 74px;
    }
  }
</style>
